export interface AboutInfo {
  brandName: string;
  brandIntro: string;
  mission: string;
  vision: string;
  story: string;
  stats: { label: string; value: string }[];
  values: { title: string; description: string; icon: string }[];
  testimonials: { name: string; avatar: string; content: string; role: string }[];
  contact: {
    email: string;
    phone: string;
    address: string;
    wechat: string;
    qq: string;
  };
}

export const aboutData: AboutInfo = {
  brandName: '韩漫网',
  brandIntro: '韩漫网成立于2023年，是国内领先的韩国漫画在线阅读平台。我们致力于为广大漫画爱好者提供高质量、正版授权的韩国漫画资源，让每一位读者都能享受到最佳的阅读体验。',
  mission: '让优质的韩国漫画触手可及，成为中文用户阅读韩漫的首选平台。',
  vision: '构建一个连接韩国漫画家与中国读者的桥梁，推动韩漫文化在中国的传播与发展。',
  story: '韩漫网的创始团队由一群热爱漫画的年轻人组成。我们深知，对于漫画爱好者来说，找到一个内容丰富、界面友好、更新及时的漫画平台有多么重要。于是，我们决定自己动手，打造一个专注于韩国漫画的优质平台。经过两年多的发展，韩漫网已经积累了数千部优质漫画资源，每天为数百万用户提供阅读服务。',
  stats: [
    { label: '收录漫画', value: '5000+' },
    { label: '活跃用户', value: '200万+' },
    { label: '日更新量', value: '100+话' },
    { label: '用户好评率', value: '98.5%' },
  ],
  values: [
    {
      title: '内容为王',
      description: '我们坚持精选优质的韩国漫画内容，每一部作品都经过严格筛选，确保为用户提供最好的阅读体验。',
      icon: 'ri-star-line',
    },
    {
      title: '用户至上',
      description: '以用户的需求为导向，不断优化产品体验。简洁的界面、流畅的阅读、智能的推荐，都是为了让您更舒适地享受漫画。',
      icon: 'ri-heart-line',
    },
    {
      title: '正版授权',
      description: '我们重视版权保护，与多家韩国漫画平台和出版社建立了合作关系，确保平台上的内容均有合法授权。',
      icon: 'ri-shield-check-line',
    },
    {
      title: '持续创新',
      description: '技术团队不断探索新的阅读技术和互动方式，为用户带来更加沉浸式的漫画阅读体验。',
      icon: 'ri-lightbulb-line',
    },
  ],
  testimonials: [
    {
      name: '李晓明',
      avatar: '',
      content: '韩漫网是我每天必刷的网站！更新速度超快，画质也很清晰，最重要的是完全免费。感谢这个平台让我发现了这么多好看的韩漫！',
      role: '忠实用户 · 使用2年',
    },
    {
      name: '王思雨',
      avatar: '',
      content: '作为一个韩漫重度爱好者，我几乎把所有韩漫平台都用过了。韩漫网的分类最细致，推荐算法也很准，总能找到我喜欢的类型。',
      role: '漫画博主 · 使用1年半',
    },
    {
      name: '张浩然',
      avatar: '',
      content: '界面简洁大方，没有乱七八糟的广告，阅读体验非常好。而且手机适配做得也很棒，在地铁上追漫特别方便。',
      role: '在校大学生 · 使用8个月',
    },
  ],
  contact: {
    email: 'contact@hanman.example.com',
    phone: '400-123-4567',
    address: '北京市朝阳区望京SOHO T2-B座 1208室',
    wechat: 'hanman_official',
    qq: '1234567890',
  },
};